<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>唐山港派车</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="物料名称:" prop="goodsName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.goodsName"></el-input>
      </el-form-item>
      <el-form-item label="码头:" prop="wharfxName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.wharfxName"></el-input>
      </el-form-item>
      <el-form-item label="车队:" prop="fleetId">
        <el-select v-model="searchFrom.fleetId" placeholder="请选择">
          <el-option
            v-for="(item,index) in fleetOptions"
            :key="index"
            :label="item.fleetName"
            :value="item.fleet">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="船名:" prop="shipName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.shipName"></el-input>
      </el-form-item>
      <el-form-item label="收货仓库1:" prop="warehouseName">
        <el-input  placeholder="" maxlength="100" v-model="searchFrom.warehouseName"></el-input>
      </el-form-item>
      <el-form-item label="创建时间:" prop="">
         <el-date-picker
          v-model="searchFrom.startTime"
          size="mini"
          type="date"
          placeholder="选择日期">
        </el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.endTime"
          size="mini"
          placeholder="选择日期"
          type="date"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="有效时间:" prop="">
         <el-date-picker
          v-model="searchFrom.validStartTime"
          size="mini"
          type="date"
          placeholder="选择日期">
        </el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.validEndTime"
          size="mini"
          placeholder="选择日期"
          type="date"
        ></el-date-picker>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchBtnClick" btnCode='001P008B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='001P008B002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="daoChu" btnCode='001P008B003' v-if="btnFlg[2]">导出</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName" label="操作" width="200" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="handledaiPaiClick(scope.row)" type="primary" size="small" btnCode='001P008B004' v-if="btnFlg[3]">待派车辆</el-button>
            <el-button @click="handleYiPaiClick(scope.row)" type="success" size="small" btnCode='001P008B005' v-if="btnFlg[4]">已派车辆</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="address" label="疏港计划" align="center" width="100" show-overflow-tooltip>
           <template slot-scope="scope"><div>
            <el-button @click="handleSeeClick(scope.row)" type="primary" size="small" btnCode='001P008B006' v-if="btnFlg[5]">查看</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="fleetName"   label="车队" align="center" width="170" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shipName" label="船名"  align="center" width="120"></el-table-column>
        <el-table-column prop="goodsName"    label="物料名称"  width="100" align="center"></el-table-column>
        <el-table-column prop="wharfxName" label="码头" align="center" width="140"></el-table-column>
        <el-table-column prop="distWeight" label="分配吨数" align="center" width="140">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.distWeight == undefined || scope.row.distWeight == null || scope.row.distWeight == ''">-</span>
            <span v-else>{{scope.row.distWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="outPortWeight"   label="出港净重（吨）" align="center" width="120">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.outPortWeight == undefined || scope.row.outPortWeight == null || scope.row.outPortWeight == ''">-</span>
            <span v-else>{{scope.row.outPortWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="SYoutPortWeight"   label="出港剩余吨数" align="center" width="120" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.SYoutPortWeight == undefined || scope.row.SYoutPortWeight == null || scope.row.SYoutPortWeight == ''">-</span>
            <span v-else>{{scope.row.SYoutPortWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="BoutPortWeight" label="出港完成率"  align="center" width="120">
           <template slot-scope="scope"><div>
            <!-- <span v-if="scope.row.BoutPortWeight == undefined || scope.row.BoutPortWeight == null || scope.row.BoutPortWeight == ''">-</span> -->
            <span>{{scope.row.BoutPortWeight}}%</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="warehouseName" label="收货仓库1"  align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="carnumLimit"    label="车数限制1"  width="100" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="locationName" label="库位1" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="areaName" label="码头场区"  align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="stackPosition"  label="码头垛位" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="finshWeight" label="进厂净重"  align="center" width="120">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.finshWeight == undefined || scope.row.finshWeight == null || scope.row.finshWeight == ''">-</span>
            <span v-else>{{scope.row.finshWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="SYfinshWeight" label="进厂剩余吨数"  width="120" align="center" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.SYfinshWeight == undefined || scope.row.SYfinshWeight == null || scope.row.SYfinshWeight == ''">-</span>
            <span v-else>{{scope.row.SYfinshWeight.toFixed(3)}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="BfinshWeight" label="进厂完成率" align="center" width="140" :formatter="emptyFn">
          <template slot-scope="scope"><div>
            <span>{{scope.row.BfinshWeight}}%</span>
          </div></template>
        </el-table-column>
        <!-- <el-table-column prop="vehicleTypesName"    label="车型"  width="130" align="center" :formatter="emptyFn"></el-table-column> -->
        <el-table-column prop="validDate" label="有效时间"  align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="cgPurplanNo"    label="采购日计划单号"  width="230" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="distributionNo" label="小计划号" align="center" width="180"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--点击查看-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="seeMark"
    width="1000px"
    center>
    <div v-loading='seeLoading'>
      <span>
        <!-- style="width:97%;margin-top:10px;margin-left:4%;margin-bottom:17px" -->
        <div class="addinpBox">
                <el-table
                  :data="seetableList"
                  ref="table"
                  border
                  bordersize="mini"
                  style="width:97%;margin:17px auto;"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
                  <el-table-column prop="planNo" label="疏港计划号" align="center" width="150"></el-table-column>
                  <el-table-column prop="shipName" label="船名" align="center"  ></el-table-column>
                  <el-table-column prop="portName" label="港口"  align="center" ></el-table-column>
                  <el-table-column prop="wharfName" label="码头" align="center" width="120" :formatter="formatterRowEmpty"></el-table-column>
                  <el-table-column prop="goodsName" label="货名"  align="center" ></el-table-column>
                  <el-table-column prop="planWeight" label="重量" align="center" :formatter="formatterRowEmpty"></el-table-column>
                  <el-table-column prop="forwarderName" label="代理"  align="center" :formatter="formatterRowEmpty"></el-table-column>
                  <el-table-column prop="controlWeight" label="车队计划量" width="120" align="center" :formatter="formatterRowEmpty"></el-table-column>
                  <el-table-column prop="vaildDate" label="有效期" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
                  <el-table-column prop="fleetName" label="车队" align="center"  width="180" :formatter="formatterRowEmpty"></el-table-column>
                </el-table>
        </div>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="seeMark = false" size='mini'>关闭</el-button>
      </div>
      </div>
    </el-dialog>
    <!-- 待派车辆 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="daiPaiMark"
    width="1100px"
    center>
    <div v-loading='daiPaiLoading'>
      <span>
        <div>
          <div class="daiPaiTop">
            <div>累计已派车次数：<span style="color:#d547ef;font-weight: 700;font-size:18px">{{daiPaiCompCount}}</span></div>
            <div>已完成车次：<span style="color:#d547ef;font-weight: 700;font-size:18px">{{daiPaiSumSendcarCount}}</span></div>
            <div>计划吨数：<span style="color:#000;font-weight: 700;font-size:18px">{{daiPaiPlanWeight}}</span></div>
            <div>已运吨数：<span style="color:#008000;font-weight: 700;font-size:18px">{{daiPaiFinshWeight}}</span></div>
            <div>剩余量：<span style="color:red;font-weight: 700;font-size:18px">{{daiPaiShengYu}}</span></div>
            <div>完成率：<span style="color:blue;font-weight: 700;font-size:18px">{{daiPaiWanChengLv}}%</span></div>
          </div>
          <hr />
          <div class="addinpBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>车牌号：</span>
            <el-input  placeholder="" maxlength="100" v-model="daiPaiFrom.vehicleNo" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <span>车型：</span> -->
            <!-- <el-input  placeholder="" maxlength="100" v-model="daiPaiFrom.vhcType" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <!-- <el-select v-model="daiPaiFrom.vhcType" placeholder="请选择" size="mini" style="width:150px;">
              <el-option
                v-for="(item,index) in carTypeOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <el-button type="primary" size="mini" @click="daiPaiSearchClick">查询</el-button>
            <el-button type="primary" size="mini" @click="daiPaiChongZhi">重置</el-button>
            <el-table
              :data="daiPaiTableList"
              ref="daiPaiTableList"
              border
              bordersize="mini"
              style="width:100%;margin:10px 0 10px 0"
              center
              :header-cell-style="{background:'#F5F5F5',color:'black'}"
              :header-row-style="{height:'35px'}"
              :row-style="{height:'25px'}"
              highlight-current-row>
              <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="vehicleNo"    label="车牌号" align="center" width="120"></el-table-column>
              <!-- <el-table-column prop="vhcName"   label="车型" align="center" width="120" ></el-table-column> -->
              <el-table-column prop="driverName"    label="司机" align="center" ></el-table-column>
              <el-table-column prop="driverMobile" label="联系电话"  align="center" ></el-table-column>
              <el-table-column prop="createTime" label="上报时间" align="center" >
                <template slot-scope="scope"><div>
            <span>{{scope.row.createTime | dateFormat}}</span>
          </div></template>
              </el-table-column>
              <el-table-column prop="fleetName" label="所属车队" align="center" ></el-table-column>
            </el-table>
                <!-- 分页 10,25,50,100-->
                <!-- <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="heTongFrom.pageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="heTongFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="heTongFrom.total">
                  </el-pagination>
                </div>-->
        </div>
        </div>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="daiPaiMark = false" size='mini'>关闭</el-button>
      </div>
      </div>
    </el-dialog>
    <!-- 已派车辆 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="yiPaiMark"
    width="1200px"
    center>
    <div v-loading='yiPaiLoading'>
      <span>
        <span>
        <div>
          <div class="daiPaiTop">
            <div>累计已派车次数：<span style="color:#d547ef;font-weight: 700;font-size:18px">{{yiPaiCompCount}}</span></div>
            <div>已完成车次：<span style="color:#d547ef;font-weight: 700;font-size:18px">{{yiPaiSumSendcarCount}}</span></div>
            <div>计划吨数：<span style="color:#000;font-weight: 700;font-size:18px">{{yiPaiPlanWeight}}</span></div>
            <div>已运吨数：<span style="color:#008000;font-weight: 700;font-size:18px">{{yiPaiFinshWeight}}</span></div>
            <div>剩余量：<span style="color:red;font-weight: 700;font-size:18px">{{yiPaiShengYu}}</span></div>
            <div>完成率：<span style="color:blue;font-weight: 700;font-size:18px">{{yiPaiWanChengLv}}%</span></div>
          </div>
          <hr />
          <div class="addinpBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>车牌号：</span>
            <el-input  placeholder="" maxlength="100" v-model="yiPaiFrom.vehicleNo" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>状态：</span>
            <el-select v-model="yiPaiFrom.waybillStatus" placeholder="请选择" size="mini" style="width:150px;">
              <el-option
                v-for="(item,index) in waybillStatusOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>派车时间：</span>
            <el-date-picker
              v-model="yiPaiFrom.startTime"
              size="mini"
              type="datetime"
              placeholder="选择日期">
            </el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="yiPaiFrom.endTime"
              size="mini"
              placeholder="选择日期"
              type="datetime"
            ></el-date-picker>
            <el-button type="primary" size="mini" @click="yiPaiSearchClick">查询</el-button>
            <el-button type="primary" size="mini" @click="yiPaiChongZhi">重置</el-button>
            <el-table
              :data="yiPaiTableList"
              ref="yiPaiTableList"
              border
              bordersize="mini"
              style="width:100%;margin:10px 0 10px 0"
              center
              :header-cell-style="{background:'#F5F5F5',color:'black'}"
              :header-row-style="{height:'35px'}"
              :row-style="{height:'25px'}"
              highlight-current-row>
              <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="waybillNo"    label="运单号" align="center" width="200"></el-table-column>
              <el-table-column prop="wbTime"   label="车队派车时间" align="center" width="180" ></el-table-column>
              <el-table-column prop="vehicleNo"    label="车牌号" align="center" width="100"></el-table-column>
              <el-table-column prop="waybillStatusName" label="运单状态"  align="center" width="100"></el-table-column>
              <el-table-column prop="driverName"    label="司机" align="center" ></el-table-column>
              <el-table-column prop="driverMobile"    label="联系电话" align="center" width="120"></el-table-column>
              <el-table-column prop="fleetName"    label="所属车队" align="center" width="180"></el-table-column>
              <el-table-column prop="sfirstTare"    label="港口一检皮重" align="center" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="sgrossWeight"   label="港口二检毛重" align="center"  width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="ssuttle"    label="出港货物净重" align="center" width="120">
                <template slot-scope="scope"><div>
                  <span v-if="scope.row.ssuttle == undefined || scope.row.ssuttle == null || scope.row.ssuttle == ''">-</span>
                  <span v-else>{{scope.row.ssuttle.toFixed(3)}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="efirstTare" label="进厂一检毛重"  align="center" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="egrossWeight"    label="出厂二检皮重" align="center" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="esuttle"    label="进厂货物净重" align="center" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="grossErrorRate"   label="毛重误差率（‰）" align="center" width="140" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="netErrorRate"    label="净重误差率（‰）" align="center" width="140" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="vpTime" label="司机上报时间"  align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="wharfOutTime"    label="出港过磅时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="plantInTime"    label="进厂时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="plantOutTime"    label="出厂时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="finishTime" label="司机完成时间"  align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="wharfCancelTime" label="撤销时间" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
            </el-table>
                <!-- 分页 10,25,50,100-->
                <!-- <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="heTongFrom.pageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="heTongFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="heTongFrom.total">
                  </el-pagination>
                </div>-->
        </div>
        </div>
      </span>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="yiPaiMark = false" size='mini'>关闭</el-button>
      </div>
    </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  fleetList,
  getDictionaryList, // 字典/
  getSendCarList, // 查询
  countSendCar, // 可派车辆-头部信息
  getVehicleReportList, // 待派车辆列表
  getVehicleYPList, // 已派车辆列表
  getBindPlanList // 查看
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  filters: {
    rounding (value) {
      return value.toFixed(3)
    }
  },
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P008B001', '001P008B002', '001P008B003',
        '001P008B004', '001P008B005', '001P008B006'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        fleetId: '',
        startTime: '',
        endTime: '',
        validStartTime: '',
        validEndTime: ''
      },
      // 车队
      fleetOptions: [],
      // 车型
      carTypeOptions: [
        {
          showName: '宏博车队',
          itemNo: '1'
        },
        {
          showName: '荣辉车队',
          itemNo: '2'
        },
        {
          showName: '瑞泰车队',
          itemNo: '3'
        },
        {
          showName: '天马车队',
          itemNo: '4'
        },
        {
          showName: '新创车队',
          itemNo: '5'
        },
        {
          showName: '中北车队',
          itemNo: '6'
        }
      ],
      // 状态
      waybillStatusOptions: [],
      value: '',
      tableList: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      planStatus: '',
      // 查看
      seetableList: [],
      seeMark: false,
      // 待派车辆
      daiPaiMark: false,
      daiPaiTableList: [],
      daiPaiFrom: {
        carNum: '',
        vhcType: ''
      },
      daiPaiCompCount: 0, // 待派车累计已派车次数
      daiPaiSumSendcarCount: 0, // 待派车已完成次数
      daiPaiPlanWeight: 0, // 待派车计划吨数
      daiPaiFinshWeight: 0, // 待派车已运吨数
      daiPaiShengYu: 0, // 待派车剩余量
      daiPaiWanChengLv: 0, // 待派车完成率
      // 已派车辆
      yiPaiMark: false,
      yiPaiTableList: [],
      yiPaiFrom: {
        vehicleNo: '',
        carType: '',
        startTime: '',
        endTime: ''
      },
      yiPaiCompCount: 0, // 已派车累计已派车次数
      yiPaiSumSendcarCount: 0, // 派车累计已完成次数
      yiPaiPlanWeight: 0,
      yiPaiFinshWeight: 0,
      yiPaiShengYu: 0,
      yiPaiWanChengLv: 0,
      // 查询
      daiPaiDistributionId: '',
      daiPaiFleetId: '',
      yiPaiDistributionId: '',
      yiPaiFleetId: '',
      tabLoading: false,
      daiPaiLoading: false,
      yiPaiLoading: false,
      seeLoading: false
    }
  },
  created () {
    this.fleetOptionsInit()
    this.getDictionaryList()
    this.getToDay()
    this.getSeatchData(this.searchFrom)
    this.btnFlg = getBtn(this.btnIdArr, '/sendCars/tsgSendCars')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'waybill_status'
      }).then(res => {
        // this.portOptions = res.wharf   // 港口
        // this.portOptions.unshift({'itemNo':'','showName':'全部'})
        // this.wharfOptions = res.wharf_1  // 码头
        // this.wharfOptions.unshift({'itemNo':'','showName':'全部'})
        this.waybillStatusOptions = res.waybill_status // 运单状态
        this.waybillStatusOptions.unshift({ 'itemNo': '', 'showName': '全部' })
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    timeStamp2: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp(new Date(new Date(new Date().toLocaleDateString()).getTime())) // 当天的早8点时间戳
      this.searchFrom.validStartTime = this.timeStamp(new Date(dateStartStr).getTime())
      this.searchFrom.validEndTime = this.timeStamp(new Date(dateStartStr).getTime() + 86400000)
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getSendCarList({
        goodsName: this.searchFrom.goodsName,
        wharfxName: this.searchFrom.wharfxName,
        fleetId: this.searchFrom.fleetId,
        shipName: this.searchFrom.shipName,
        warehouseName: this.searchFrom.warehouseName,
        startTime: this.timeStamp(this.searchFrom.startTime),
        endTime: this.timeStamp(this.searchFrom.endTime),
        validStartTime: this.timeStamp(this.searchFrom.validStartTime),
        // validStartTime: '', // 切zhbessdb_0325库之后改传值    //系统迁移后数据切割时韦苗苗要求改的，改为前一天至今天
        validEndTime: this.timeStamp(this.searchFrom.validEndTime),
        pageNo: this.searchFrom.pageNo,
        pageSize: this.searchFrom.pageSize
      }).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        // console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchBtnClick () {
      this.getSeatchData()
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        validStartTime: '',
        validEndTime: ''
      }
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.heTongMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      // this.getSearchData()
    },
    // 待派车辆
    handledaiPaiClick (row) {
      this.title = '待派车辆'
      this.daiPaiMark = true
      this.daiPaiDistributionId = row.distributionId
      this.daiPaiFleetId = row.fleetId
      this.daiPaiLoading = true
      countSendCar({
        distributionId: row.distributionId
      }).then(res => {
        this.daiPaiLoading = false
        this.daiPaiCompCount = res.sum_sendcar_count
        this.daiPaiSumSendcarCount = res.comp_count
      }).catch(err => {
        this.daiPaiLoading = false
        DonMessage.error(err.message)
      })
      this.daiPaiPlanWeight = row.distWeight
      this.daiPaiFinshWeight = row.finshWeight
      this.daiPaiShengYu = (row.distWeight - row.finshWeight).toFixed(3)
      this.daiPaiWanChengLv = ((row.finshWeight / row.distWeight) * 100).toFixed(2)
      this.daiPaiLoading = true
      getVehicleReportList({
        distributionId: row.distributionId,
        fleetId: row.fleetId,
        vehicleNo: this.daiPaiFrom.vehicleNo,
        vhcType: this.daiPaiFrom.vhcType,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        this.daiPaiLoading = false
        this.daiPaiTableList = res.list
      }).catch(err => {
        this.daiPaiLoading = false
        DonMessage.error(err.message)
      })
    },
    // 待派车辆查询
    daiPaiSearchClick () {
      this.daiPaiLoading = true
      getVehicleReportList({
        distributionId: this.daiPaiDistributionId,
        fleetId: this.daiPaiFleetId,
        vehicleNo: this.daiPaiFrom.vehicleNo,
        vhcType: this.daiPaiFrom.vhcType,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        this.daiPaiLoading = false
        this.daiPaiTableList = res.list
      }).catch(err => {
        this.daiPaiLoading = false
        DonMessage.error(err.message)
      })
    },
    // 待派重置
    daiPaiChongZhi () {
      this.daiPaiFrom = {
        carNum: '',
        vhcType: ''
      }
      this.daiPaiLoading = true
      getVehicleReportList({
        distributionId: this.daiPaiDistributionId,
        fleetId: this.daiPaiFleetId,
        vehicleNo: this.daiPaiFrom.vehicleNo,
        vhcType: this.daiPaiFrom.vhcType,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        this.daiPaiLoading = false
        this.daiPaiTableList = res.list
      }).catch(err => {
        this.daiPaiLoading = false
        DonMessage.error(err.message)
      })
    },
    // 已派车辆
    handleYiPaiClick (row) {
      this.title = '已派车辆'
      this.yiPaiMark = true
      this.yiPaiDistributionId = row.distributionId
      this.yiPaiFleetId = row.fleetId
      this.yiPaiLoading = true
      countSendCar({
        distributionId: row.distributionId
      }).then(res => {
        this.yiPaiLoading = false
        this.yiPaiCompCount = res.sum_sendcar_count
        this.yiPaiSumSendcarCount = res.comp_count
      }).catch(err => {
        this.yiPaiLoading = false
        DonMessage.error(err.message)
      })
      this.yiPaiPlanWeight = row.distWeight
      this.yiPaiFinshWeight = row.finshWeight
      this.yiPaiShengYu = (row.distWeight - row.finshWeight).toFixed(3)
      this.yiPaiWanChengLv = ((row.finshWeight / row.distWeight) * 100).toFixed(2)
      this.yiPaiLoading = true
      let startTime = ''
      let endTime = ''
      if (this.yiPaiFrom.startTime !== '') {
        startTime = this.timeStamp2(this.yiPaiFrom.startTime)
      } else {
        startTime = ''
      }
      if (this.yiPaiFrom.endTime !== '') {
        endTime = this.timeStamp2(this.yiPaiFrom.endTime)
      } else {
        endTime = ''
      }
      getVehicleYPList({
        distributionId: row.distributionId,
        fleetId: row.fleetId,
        vehicleNo: this.yiPaiFrom.vehicleNo,
        waybillStatus: this.yiPaiFrom.waybillStatus,
        startTime: startTime,
        endTime: endTime,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        this.yiPaiLoading = false
        this.yiPaiTableList = res.list
      }).catch(err => {
        this.yiPaiLoading = false
        DonMessage.error(err.message)
      })
    },
    // 已派车辆查询
    yiPaiSearchClick () {
      this.yiPaiLoading = true
      let startTime = ''
      let endTime = ''
      if (this.yiPaiFrom.startTime !== '') {
        startTime = this.timeStamp2(this.yiPaiFrom.startTime)
      } else {
        startTime = ''
      }
      if (this.yiPaiFrom.endTime !== '') {
        endTime = this.timeStamp2(this.yiPaiFrom.endTime)
      } else {
        endTime = ''
      }
      getVehicleYPList({
        distributionId: this.yiPaiDistributionId,
        fleetId: this.yiPaiFleetId,
        vehicleNo: this.yiPaiFrom.vehicleNo,
        waybillStatus: this.yiPaiFrom.waybillStatus,
        startTime: startTime,
        endTime: endTime,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        this.yiPaiLoading = false
        this.yiPaiTableList = res.list
      }).catch(err => {
        this.yiPaiLoading = false
        DonMessage.error(err.message)
      })
    },
    // 已派车辆重置
    yiPaiChongZhi () {
      this.yiPaiFrom = {
        vehicleNo: '',
        waybillStatus: '',
        startTime: '',
        endTime: ''
      }
      this.yiPaiLoading = true
      getVehicleYPList({
        distributionId: this.yiPaiDistributionId,
        fleetId: this.yiPaiFleetId,
        vehicleNo: this.yiPaiFrom.vehicleNo,
        waybillStatus: this.yiPaiFrom.waybillStatus,
        startTime: this.timeStamp(this.yiPaiFrom.startTime),
        endTime: this.timeStamp(this.yiPaiFrom.endTime),
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        this.yiPaiLoading = false
        this.yiPaiTableList = res.list
      }).catch(err => {
        this.yiPaiLoading = false
        DonMessage.error(err.message)
      })
    },
    // 点击列表查看
    handleSeeClick (row) {
      this.title = '疏港计划'
      this.seeMark = true
      this.seeLoading = true
      getBindPlanList({
        distributionId: row.distributionId,
        vehicleNo: '',
        vhcType: '',
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        this.seeLoading = false
        this.seetableList = res.list
      }).catch(err => {
        this.seeLoading = false
        DonMessage.error(err.message)
      })
    },
    // 导出
    daoChu () {
      this.$confirm('是否进行此操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          exportExcel(
            '/zw56-zhb-ess-server/zhbess/sendCar/exportExcel',
            this.searchFrom,
            '唐山港派车列表'
          )
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 15px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.inpBox .el-date-editor{
    // width: 280px!important;
 }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -5px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.daiPaiTop{
  width: 99%;
  margin: 20px auto;
  display: flex;
  justify-content: space-around;
  div{
    color: #909090;

  }
}
</style>
